import kupuRame from "../../Assets/AsetAnanta/kupu1.png";
import asetAnanta2 from "../../Assets/AsetAnanta/2.png";
import asetAnanta1 from "../../Assets/AsetAnanta/1.png";

export const ParticleConfig = {
  particles: {
    number: {
      value: 5,
      density: {
        enable: true,
        value_area: 800,
      },
    },
    color: "#f1ed89",
    shape: {
      type: "image",
      image: [
        {
          src: kupuRame,
          width: 100,
          height: 100,
        },
        {
          src: asetAnanta2,
          width: 100,
          height: 100,
        },
        {
          src: asetAnanta1,
          width: 100,
          height: 100,
        },
      ],
    },
    opacity: {
      value: 0.5,
      random: false,
      anim: {
        enable: false,
        speed: 1,
        opacity_min: 0.5,
        sync: false,
      },
    },
    size: {
      value: 20,
      random: true,
      anim: {
        enable: false,
        speed: 40,
        size_min: 20,
        sync: false,
      },
    },
    line_linked: {
      enable: false,
    },
    move: {
      enable: true,
      speed: 1,
      direction: "none",
      random: false,
      straight: false,
      out_mode: "out",
      bounce: false,
      attract: {
        enable: false,
        rotateX: 600,
        rotateY: 1200,
      },
    },
  },
  interactivity: {
    detect_on: "window",
    events: {
      onhover: {
        enable: true,
        mode: "repulse",
      },
      onclick: {
        enable: false,
        mode: "push",
      },
      resize: true,
    },
    modes: {
      grab: {
        distance: 400,
        line_linked: {
          opacity: 0,
        },
      },
      bubble: {
        distance: 400,
        size: 40,
        duration: 2,
        opacity: 8,
        speed: 3,
      },
      repulse: {
        distance: 200,
        duration: 0.4,
      },
      push: {
        particles_nb: 4,
      },
      remove: {
        particles_nb: 2,
      },
    },
  },
  retina_detect: false,
};